'use strict';

/**
 * Check if a postal code is valid according to our bpost list.
 */
customerZone.directive('validatePostalCode', ['$log', 'CityProvider', function ($log, CityProvider) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var cities = [];
            CityProvider.getCities()
                .then(function(_cities_){
                    cities = _cities_;
                })
                .catch(function(error){
                    $log.error('Failed to load cities', error);
                });
            ctrl.$parsers.push(function(value){
                var countryIso2 = attrs.validatePostalCode ? scope.$eval(attrs.validatePostalCode) : 'be';
                if (countryIso2 !== 'be') return value;
                var knownCodes = cities.map(function(city){ return city.postalCode; });
                if (value === '') return '';
                else {
                    var valid = knownCodes.includes(value);
                    if (!valid) return undefined;
                    return value;
                }
            });
        }
    };
}]);
